const mutations = {
  SET_SOPS(state, payload) {
    state.sops = payload;
  },
  SET_SOP(state, payload) {
    state.sop = payload;
  },
};

export default mutations;
